import { toPaise } from '@/utils/money';
import { pluralize } from '@/utils/text';

/** How long a plan runs: months, or days for a day pass. Exactly one is set. */
export interface PlanDuration {
  durationMonths: number | null;
  durationDays: number | null;
}

/** "3 months", or "1 day" for a day pass. */
export function planDurationLabel(plan: PlanDuration): string {
  return plan.durationDays !== null
    ? pluralize(plan.durationDays, 'day')
    : pluralize(plan.durationMonths ?? 0, 'month');
}

export function isDayPass(plan: PlanDuration): boolean {
  return plan.durationDays !== null;
}

/** A day pass that costs nothing — a member may take one once (the API enforces it). */
export function isFreeTrial(plan: PlanDuration & { price: string }): boolean {
  return isDayPass(plan) && toPaise(plan.price) === 0;
}
